interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={align === 'center' ? 'text-center' : ''}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
          <i className="ri-flashlight-fill" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-[32px] md:leading-tight">
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 text-sm leading-relaxed text-foreground-600 md:text-base ${
            align === 'center' ? 'mx-auto max-w-2xl' : 'max-w-2xl'
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}

export default SectionHeading;